import EmailInfoComponent from './EmailInfoContainer';

export default EmailInfoComponent;